import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';

@Component({
  selector: 'app-add-clone-ro',
  standalone: true,
  imports: [
    CommonModule,

    MatDialogActions,
    MatButton,
    MatDialogTitle
  ],
  templateUrl: './add-clone-ro.component.html',
  styleUrl: './add-clone-ro.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class AddCloneRoComponent {

  constructor(
    private dialogRef: MatDialogRef<AddCloneRoComponent>,
  ){}

  close(result: number): void {
    this.dialogRef.close(result);
  }

}

